const getEndOfToday = (): {endDate: Date, startDate: Date} => {
  const now = new Date().getTime();
  const startDate = new Date(now - (now % 86400000));
  const endDate = new Date(now - (now % 86400000) + 97140000);
  return { endDate, startDate };
};

export default getEndOfToday;
